import { FC, useState } from "react";
import Checkbox from "antd/lib/checkbox/Checkbox";
import { Button, Form, Input } from "antd";
import styles from "./styles.module.css";
import { phoneValid } from "../../../utils";
import { useAppDispatch, useAppSelector } from "../../../store";
import { SetMarketingAgreement, SetPhone } from "../../../store/slices/registrationSlice";
import { tabsNamesKeys } from "../Registration.models";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { signupByPhone } from "../../../store/actions/registrationAction";

interface IPhoneProps {
  setStep: (step: tabsNamesKeys) => void;
}

interface IRegistrationPhoneFormValues {
  termsOfUse: boolean;
  personalDataUse: boolean;
  mailings: boolean;
  phone: string;
}

const Phone: FC<IPhoneProps> = ({ setStep }) => {
  const dispatch = useAppDispatch();
  const { _isLoading } = useAppSelector((state) => state.registrationSlice);

  const [form] = Form.useForm<IRegistrationPhoneFormValues>();

  const [isSubmittable, setIsSubmittable] = useState(false);

  const onValuesChange = (_: any, allValues: IRegistrationPhoneFormValues) => {
    const { termsOfUse, personalDataUse, phone } = allValues;
    const isValid = termsOfUse && personalDataUse && Boolean(phone?.length);

    setIsSubmittable(isValid);
  };

  const onPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.replace(/\D/g, "");
    if (!value.startsWith("+")) {
      value = "+" + value;
    }
    form.setFieldsValue({ phone: value });
  };

  const onFinishHandler = (values: IRegistrationPhoneFormValues) => {
    let { phone, mailings } = values;

    dispatch(SetPhone(phone));
    dispatch(SetMarketingAgreement(mailings));

    dispatch(signupByPhone({ setStep }));
  };

  return (
    <div className="passport">
      <p className={styles.subtitle}>Введите номер телефона</p>
      <Form
        form={form}
        onValuesChange={onValuesChange}
        layout="vertical"
        onFinish={onFinishHandler}
      >
        <Form.Item
          name="phone"
          rules={[
            {
              required: true,
              message: "Пожалуйста, введите номер телефона",
            },
            {
              pattern: phoneValid,
              message: "Неверный формат номера телефона",
            },
          ]}
        >
          <Input
            className={styles.inputPhone}
            placeholder="Ваш номер телефона"
            onChange={onPhoneChange}
            maxLength={16}
            type="tel"
          />
        </Form.Item>
        <Form.Item name="termsOfUse" valuePropName="checked" required={true}>
          <Checkbox>
            Я ознакомился с{" "}
            <a
              href="https://s3-api.unionepro.ru/basebucket/web/docs/Consent%20to%20the%20Processing%20of%20Personal%20Data.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              условиями пользования
            </a>
          </Checkbox>
        </Form.Item>
        <Form.Item
          name="personalDataUse"
          valuePropName="checked"
          required={true}
        >
          <Checkbox>
            Я даю согласие на{" "}
            <a
              href="https://s3-api.unionepro.ru/basebucket/web/docs/Policy_processing_personal%20Data.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              обработку персональных данных
            </a>
          </Checkbox>
        </Form.Item>
        <Form.Item name="mailings" valuePropName="checked" required={true}>
          <Checkbox>
            Я соглашаюсь получать маркетинговые рассылки с эксклюзивными
            предложениями и новостями.{" "}
            <a
              href="https://innopolis.university/filespublic/Polozhenie_o_reklamnoj_rassylke.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Положение о рекламной рассылке
            </a>
          </Checkbox>
        </Form.Item>
        <Form.Item shouldUpdate>
          <Button
            type="primary"
            htmlType="submit"
            disabled={!isSubmittable || _isLoading}
            className={styles.nextButton}
            block
          >
            Далее
          </Button>
        </Form.Item>
        <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          className={styles.backButton}
          onClick={setStep.bind(null, tabsNamesKeys.passport)}
        >
          Вернуться к вводу личных данных
        </Button>
      </Form>
    </div>
  );
};

export default Phone;
